export const social_link = {
    facebook:'https://www.facebook.com/profile.php?id=61551717885156',
    instagram:'https://www.instagram.com/primus_agents/',
    twitter:'#twitter',
    linkedin:'#linkedin',
    youtube:'https://www.youtube.com/channel/UC8Wv2v6E1drO6uZE2vmuSjA',
}